var site = site || {};
var generic = generic || {};

site.defaultCountry = site.defaultCountry || {};

(function ($) {
  Drupal.behaviors.csContactForms = {
    /**
     * Flag to ensure this JS is only attached once.
     * @type {boolean}
     */
    attached: false,

    /**
     * Hides the thank you section of the form.
     */
    hideItems: function () {
      $('.js-cs-contact-form-thanks').addClass('hidden');
    },

    /**
     * Sends out an RPC call for the contact form.
     */
    submitContactForm: function (event) {
      event.preventDefault();

      var $contactForm = $('.js-cs-contact-form');
      var enableLoading = $('.js-loading-message', $contactForm).length ? 1 : 0;
      var $btnElements = $('.js-loading-message, .js-contact-submit', $contactForm);

      if (enableLoading) {
        $btnElements.toggleClass('hidden');
      }
      var $contactFormErrors = $('.js-cs-contact-form-errors');
      var $parentGrid = $contactForm.closest('.js-grid');

      // Reset all input fields display.
      $('input,select,textarea,[name=QUESTION]', $contactForm).removeClass('error');

      // Put the form values into an object.
      var parametersArray = $contactForm.serializeArray();
      var parametersObject = {};

      $.each(parametersArray, function (index, param) {
        parametersObject[param.name] = param.value;
      });

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [parametersObject],
        onSuccess: function () {
          $contactFormErrors.hide();
          $('.js-cs-contact-form-thanks').removeClass('hidden');
          $('.js-cs-contact-form-call').addClass('hidden');
          $contactForm.hide();
          var linktest = $('.site-content');

          $('html, body').animate(
            {
              scrollTop: $(linktest).offset().top
            },
            800
          );
          // if we are inside a grid, recalculate heights on click
          if ($parentGrid.length) {
            $parentGrid.trigger('grid.reflow');
          }
        },
        onFailure: function (jsonRpcResponse) {
          // Get errors back and build a set of list items to inject into the HTML.
          var errorObjectsArray = jsonRpcResponse.getMessages();
          var errorHTML = '';

          if (enableLoading) {
            $btnElements.toggleClass('hidden');
          }

          for (var i = 0; i < errorObjectsArray.length; i++) {
            errorHTML += '<li>' + errorObjectsArray[i].text + '</li>';

            // Use the jsonRpcResponse key to pair with input nodes.
            // Error keys are returned as "required.**FIELD**.**FORM**".
            // Match the **FIELD** in a javascript match.
            var fieldName = errorObjectsArray[i].key
              ? errorObjectsArray[i].key.match(/\w*.(\w*)./)
              : '';

            // Check if there is a match.
            if (fieldName && fieldName[1]) {
              // If match, get the matching input nodes to add the error class.
              var $node = $('[name=' + fieldName[1].toUpperCase() + ']', $contactForm);

              $node.addClass('error');
            }
          }
          $contactFormErrors.html(errorHTML).show();

          // Scroll the page to top of error list node adjusting for the nav.
          var errorsPosition = $contactFormErrors.position();
          var scrollTop =
            errorsPosition && errorsPosition.top
              ? errorsPosition.top + $('.site-header').height()
              : '';

          $('html, body').animate(
            {
              scrollTop: scrollTop
            },
            1000
          );
          // if we are inside a grid, recalculate heights on click
          if ($parentGrid.length) {
            $parentGrid.trigger('grid.reflow');
          }
        }
      });
    },

    /**
     * Sets up events for this template.
     * @param {Object} context - the DOM scope, usually document.
     */
    setEvents: function () {
      $('.js-cs-contact-form').on('submit', this.submitContactForm);
    },

    /**
     * Calls all methods for setting up this template's JS.
     * @param {Object} context - the DOM scope, usually document.
     */
    init: function (context) {
      var self = this;

      $('.js-cs-contact-form-v1', context).each(function () {
        self.hideItems();
        self.setEvents();
      });
    },

    /**
     * Standard method for attaching the template's JS.
     * @param {Object} context - the DOM scope, usually document.
     * @param {Object} settings - useful collection of site info.
     */
    attach: function (context) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      this.init(context);
    }
  };
})(jQuery);
